import React, { FC } from 'react';

import { Layout } from './Layout';
import { Message, MessageType } from './Message';
import messages from './messages';

export interface EmptyStateProps {
  message?: MessageType;
  resource?: string;
}
export const EmptyState: FC<EmptyStateProps> = ({ message = 'resource', resource = '' }) => {
  const text = resource ? (
    <Message definedMessage={messages.empty} values={{ resource }} />
  ) : (
    <Message message={message} />
  );

  return <Layout nodes={[text]} />;
};
